import { useMemo } from "react";

import { DEFAULT_FONT_SIZE } from "constants/chart.constants";

import { IChartScreenshotSettings } from "models/chart";
import { WidgetComponentType } from "models/screenshot";

import {
  useScreenshotContext,
  useScreenshotPresetContext
} from "components/screenshot/hooks";

function useXDAScreenshotCalculatedDefaults(): IChartScreenshotSettings {
  // hooks
  const { widget } = useScreenshotContext();
  const { selectedPreset: preset } = useScreenshotPresetContext();

  return useMemo(() => {
    return widget?.widgetComponentType !== WidgetComponentType.XdaViewer
      ? {}
      : {
          legendVisible: true,
          legendOpacity: 1,
          legendBorderVisible: true,
          // EVA-29 spacing measurement legend — independent of the 3D geo
          // model legend settings above.
          spacingLegendVisible: true,
          spacingLegendOpacity: 1,
          spacingLegendBorderVisible: true,
          legendFontSize: preset?.legendFontSize ?? DEFAULT_FONT_SIZE,
          legendTitleSize: preset?.legendTitleSize ?? DEFAULT_FONT_SIZE
        };
  }, [
    widget?.widgetComponentType,
    preset?.topsLabelsFontSize,
    preset?.dataLabelsFontSize,
    preset?.gridLabelsFontSize,
    preset?.legendTitleSize,
    preset?.legendFontSize
  ]);
}

export default useXDAScreenshotCalculatedDefaults;
